import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { PrimaryButton as Button } from 'jl-design-system/elements/button/Button';
import { CloseOutlined } from 'jl-design-system/components/icons/CloseOutlined';
import styles from './FlyoutMenu.scss';

export const CloseButton = ({ onClose, className }) => {
  return (
    <Button
      className={classNames(styles.close, className)}
      onClick={onClose}
      data-testid="nav-close-button"
      size="small"
    >
      <CloseOutlined
        className={styles.icon}
        dataTestId="flyout-close-button"
        size="medium"
        title="Close"
      />
      <span className={styles.visuallyHidden}>Close</span>
    </Button>
  );
};

CloseButton.propTypes = {
  onClose: PropTypes.func.isRequired,
};
